import React from 'react';
import { api, host, isJson } from './Module';
import BG2 from './Designer.jpeg';
import './Login.css';

export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Email: "",
            Pwd: "",
            clsLogin: "",
            btnLogin: false,
            Profile: {}
        };
    }

    async componentDidMount() {
        let profile = await api("controler/profile_api", { act: "data profile" }, true);
        if (profile.status == "sukses") {
            document.title = "Sistem akademin " + profile.data.Nama;
            document.getElementById('linkIconHeader').href = 'https://apis.naylatools.com/' + profile.data.Logo;
            document.getElementById('linkIcoHeader').href = 'https://apis.naylatools.com/' + profile.data.Logo;
            document.documentElement.style.setProperty('--color-primary', profile.data.ColorDefault);
            this.setState({ Profile: profile.data });
        }
    }

    async handleLogin(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.target.checkValidity()) {
            this.setState({ btnLogin: true, clsLogin: "spinner-border spinner-border-sm text-light" });
            let data = new FormData(e.target);
            data.append("UserType", "Admin");
            data.append("Domain", window.location.hostname);
            fetch(host + "login", {
                method: 'POST',
                body: data,
            }).then(response => response.text()).then(res => {
                if (isJson(res)) {
                    let hasil = JSON.parse(res);
                    if (hasil.status === "sukses") {
                        localStorage.setItem("TokenAdmin", hasil.token);
                        window.location.reload();
                    } else {
                        this.setState({ btnLogin: false, clsLogin: "" });
                        alert(hasil.pesan);
                    }
                } else {
                    console.log(res);
                    alert("Terjadi kesalahan");
                }
            }).catch((error) => {
                this.setState({ btnLogin: false, clsLogin: "" });
                console.log("Error: " + error);
            });
        } else {
            let forms = document.getElementsByClassName('needs-validation');
            let ululu = Array.prototype.filter.call(forms, function (form) {
                form.classList.add('was-validated');
            });
        }
    }

    handleVisible(e) {
        let cls = e.target;
        let edtPwd = document.getElementById('edtPwd');
        if (edtPwd.type == "password") {
            cls.classList.remove("fa-eye-slash");
            cls.classList.add("fa-eye");
            edtPwd.type = "text";
        } else {
            cls.classList.add("fa-eye-slash");
            cls.classList.remove("fa-eye");
            edtPwd.type = "password";
        }
    }

    render() {
        return (
            <section>
                <div className="row">
                    <div className="col-md-8">
                        <div className="div-img-top">
                            <img src={host.replaceAll("/siamik", "") + this.state.Profile.Logo} className="logo" alt="Logo" />
                        </div>
                        <div className="card-form">
                            <form id="formLogin" className="needs-validation" onSubmit={(e) => this.handleLogin(e)} noValidate>
                                <h4 style={{ color: "#fefefe" }}>Login</h4>
                                <h6 style={{ color: "#fefefe" }}>Selamat datang kembali di {this.state.Profile.Nama}</h6>
                                <div className="form-group">
                                    <label>Email</label>
                                    <input type="text" name="UserName" className="form-control form-control-lg" id="edtEmail" value={this.state.Email} onChange={(e) => this.setState({ Email: e.target.value })} required />
                                    <div className="invalid-feedback">Silahkan masukan alamat email</div>
                                </div>
                                <div className="form-group">
                                    <label>Password</label>
                                    <div className="input-group">
                                        <input type="password" name="Password" className="form-control form-control-lg" id="edtPwd" value={this.state.Pwd} onChange={(e) => this.setState({ Pwd: e.target.value })} required />
                                        <div className="invalid-feedback">Silahkan masukan password</div>
                                        <i className="fas fa-eye-slash btn-opsi" id="btnVisibility" onClick={(e) => this.handleVisible(e)}></i>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end" style={{ marginBottom: "24px" }}>
                                    <span className="btn-link" style={{ fontWeight: "bold", cursor: "pointer" }} data-bs-toggle="modal" data-bs-target="#modal">Lupa Password?</span>
                                </div>
                                <button className=" btn btn-lg w-100 btn-login" id="btnLogin">
                                    <i id="lblLoading" className={this.state.clsLogin}></i> Login
                                </button>
                                <center>
                                    <div class="mt-3" id="google-signin"></div>
                                </center>
                                <div className="alert alert-danger" id="lblNotif" style={{ display: "none", marginTop: "1rem" }} role="alert"></div>
                            </form>
                        </div>
                    </div>
                    <div className="col-md-4" style={{ padding: "0px" }}>
                        <div className="bg-side">
                            <img src={BG2} className="img-side-bottom"></img>
                        </div>
                    </div>
                    <div id='divPesan'></div>
                </div>

                <div className="modal fade" id="modal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <form id="formForgot" className="needs-validation" noValidate>
                                <div className="modal-header" id="modalHeader">
                                    <h5 className="modal-title" id="exampleModalLabel">Lupa Password</h5>
                                    <button type="button" className="btn btn-close-modal" data-bs-dismiss="modal" id="dismissModal">
                                        <span className="material-icons">close</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <input type="hidden" name="act" value="request" />
                                    <div className="form-group">
                                        <label>Alamat Email</label>
                                        <input type="email" name="email" className="form-control form-control-lg" id="edtEmailForgot" placeholder="Silahkan masukan alamat email anda" required />
                                        <div className="invalid-feedback">Silahkan Masukan Alamat Email</div>
                                    </div>
                                    <p></p>
                                    <div className="alert alert-danger" id="divAlert" style={{ display: "none" }} role="alert"></div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
                                    <button type="submit" className="btn btn-login" id="btnForgot"><i id="lblDaftar" disabled></i> Kirim Permintaan</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}